import React from 'react'
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {NewProductView } from './NewProduct'
import {SingleProductView } from './Product'
import {ProductConfigurationView} from './ProductConfiguration'
import {ComboView} from './Combo'
import {QrsView} from './Qrs'

import { ADMIN_ROLE } from '../../constants'
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/user';
import { bindActionCreators } from 'redux';

function mapStateToProps(state) {
    return {
        userRoles: state.user.userRoles

    };
}

function mapDispatchToProps(dispatch) {
    return {}
}



const paperStyle = {
    marginTop: 100,
    paddingBottom: 50,
    paddingTop: 25,
    padding: 20,
    width: '100%',
    textAlign: 'left',
    display: 'inline-block',
};


@connect(mapStateToProps, mapDispatchToProps)
class ProductView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            tab: 0,

        }
        this.handleClick = this.handleClick.bind(this);
        this.changeTab = this.changeTab.bind(this);
    }


    handleClick(e) {
        this.setState({ open: true });
    }



    changeTab(event, value) {
        this.setState({ tab: value });
    }


    render() {
        const isAdmin = this.props.userRoles.includes(ADMIN_ROLE)

        return (
            <Paper style={paperStyle}>
                <Tabs
                    value={this.state.tab}
                    onChange={this.changeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Producto" />
                    {isAdmin &&<Tab label="Combos" />}
                    {isAdmin &&<Tab label="Altas de Nuevos productos" />}
                    {isAdmin && <Tab label="Configuracion de Productos" />}
                    {<Tab label="QRs" />}
                </Tabs>
                {this.state.tab === 0 && <SingleProductView />}
                {this.state.tab === 1 && <ComboView />}
                {this.state.tab === 2 && <NewProductView />}
                {this.state.tab === 3 && <ProductConfigurationView />}
                {this.state.tab === 4 && <QrsView />}
            </Paper>

        )
    }
}

export default ProductView


// WEBPACK FOOTER //
// ./src/components/Products/ProductView.js